import { FileCollectionItemT, FileCollectionT, ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement, useEffect, useState } from 'react';
import { ArrowForwardIosRounded } from '@material-ui/icons';
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';
import { IconButton } from '@material-ui/core';
import { isMobile } from '../../../../../utils/app.helper';
import BrandingService from '../../../../../services/branding.service';

type ObjectViewMobileImageGalleryProps={
    selectedObject?: ObjectContainerClientT;
    id?: string;
    fileCollections?: FileCollectionT[];
};

const ObjectViewMobileImageGallery: React.FC<ObjectViewMobileImageGalleryProps> = ({ selectedObject, fileCollections }): ReactElement => {
    const [iGFullscreen, setIGFullscreen] = useState(false);
    const [imageItems, setImageItems] = useState<ReactImageGalleryItem[]> ();
    const [currentImage, setCurrentImage] = useState<FileCollectionItemT>();

    useEffect(() => {
        setImageItems(selectedObject && fileCollections?.find(fc => {
            return fc.id === selectedObject.imageCollectionId;
        })?.files?.slice().sort((a, b) => {
            return a.sortOrder - b.sortOrder;
        })
            ?.filter(f => f.type === 'image')
            .map((img) => {

                if (img.type === 'image' && img.url)
                    return { original: img.url.medium, thumbnail: img.url.small, originalClass: iGFullscreen ? 'bv-img-gallery-fullscreen' : '' };
                else
                    return { original: '', thumbnail: '', originalClass: iGFullscreen ? 'bv-img-gallery-fullscreen' : '' };

            }));


    }, [selectedObject, fileCollections, setImageItems, iGFullscreen]);

    const RenderType: React.FC = ({ children }) => {
        if (isMobile()) {
            return (
                <div className={'bv-object-view-mobile-content-right-aspect bv-object-view-mobile-main-content-mobile'} >
                    <div>
                        {children}
                    </div>
                </div>);
        }
        else {
            return <>{children}</>;
        }
    };

    return (
        <RenderType>
            <ImageGallery
                showFullscreenButton={false}
                showPlayButton={false}
                showThumbnails={!isMobile()}
                showBullets={isMobile()}
                infinite={false}
                onScreenChange={(value: boolean) => {
                    setIGFullscreen(value);
                }}
                renderLeftNav={(onClick) => (<IconButton className={'bv-object-view-mobile-image-button bv-object-view-mobile-image-button-left'} onClick={onClick} style={{ marginLeft: !isMobile() ? '2rem' : 'unset' }}><ArrowForwardIosRounded /></IconButton>)}
                renderRightNav={(onClick) => (<IconButton className={'bv-object-view-mobile-image-button bv-object-view-mobile-image-button-right'} onClick={onClick} ><ArrowForwardIosRounded /></IconButton>)}
                items={imageItems || []}/>
            {/*currentImage && currentImage.caption && currentImage.caption !== '' && <div className={'bv-objectview-content-caption'}><p>{currentImage.caption}</p></div>*/}
        </RenderType>
    );
};


export default ObjectViewMobileImageGallery;